var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBienIconNoir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    id: "Fill-1",
    className: "cls-1",
    d: "M278.928,318.673V280.52h70.336v82.924H278.928Zm31.363,73.544h67.746V251.747H250.155v140.47h60.136Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    id: "Fill-2",
    className: "cls-1",
    d: "M249.863,35,24.628,235.807l14.689,16.487v211.4h85.7V279.83h56.827V463.689H446.57V248.668l9.639,8.6,19.163-21.465-28.96-25.824L273.731,56.033l.23-.158L259.977,43.761,251.6,36.3l-.144.086ZM68.09,235.62,250.007,73.412l167.79,149.6v211.9H210.617V251.042H96.244V434.916H68.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBienIconNoir);
export default __webpack_public_path__ + "static/media/BienIconNoir.8cb97f3a1ff95167ca39ea92e4f1de62.svg";
export { ForwardRef as ReactComponent };